import { render, staticRenderFns } from "./EditProductPage.vue?vue&type=template&id=0cd238d0&scoped=true&"
import script from "./EditProductPage.vue?vue&type=script&lang=js&"
export * from "./EditProductPage.vue?vue&type=script&lang=js&"
import style0 from "./EditProductPage.vue?vue&type=style&index=0&id=0cd238d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd238d0",
  null
  
)

export default component.exports